import * as v from 'valibot';

import { newSchema } from '../../../../../utils/valibot/schema';

export type RetailCrmLegalEntitiesResponse = RetailCrmLegalEntitiesForCountry[];

export interface RetailCrmLegalEntitiesForCountry {
  countryCode: string;
  legalEntities: RetailCrmLegalEntity[];
}

export interface RetailCrmLegalEntity {
  distributionPartnerNr: string;
  name: string;
}

const internalRetailCrmLegalEntitySchema = v.object({
  distributionPartnerNr: v.string(),
  name: v.nullish(v.string()),
});

export const RetailCrmRelatedDealerSchema = newSchema(
  'RetailCrmRelatedDealerSchema',
  internalRetailCrmLegalEntitySchema,
);

/** Extends RetailCrmLegalEntity with selection flag by using Duck Typing */
export const RetailCrmRelatedDealersSelectionSchema = newSchema(
  'RetailCrmRelatedDealersSelectionSchema',
  v.object({
    ...internalRetailCrmLegalEntitySchema.entries,
    selected: v.boolean(),
  }),
);

export const RetailCrmRelatedDealersResponseSchema = newSchema(
  'RetailCrmRelatedDealersResponseSchema',
  v.array(RetailCrmRelatedDealerSchema),
);

export type RetailCrmRelatedDealer = v.InferOutput<typeof RetailCrmRelatedDealerSchema>;
export type RetailCrmRelatedDealersSelection = v.InferOutput<typeof RetailCrmRelatedDealersSelectionSchema>;
export type RetailCrmRelatedDealersResponse = v.InferOutput<typeof RetailCrmRelatedDealersResponseSchema>;
